export enum MEMBER_DERIVED_LOB {
  GOVERNMENT_MEDICARE_SUPPLEMENTAL = 'Government-Medicare Supplemental',
  GOVERNMENT_PDP = 'Government-PDP',
  GOVERNMENT_MEDICAID = 'Government-Medicaid',
  GOVERNMENT_MEDICARE = 'Government-Medicare',
}

export enum MEMBER_DATA_SOURCE {
  TMG = 'TMG',
  VMS = 'VMS',
}

export enum MEMBER_PRODUCT_TYPE {
  MSUPNS = 'MSUPNS',
  MSUPS = 'MSUPS',
  DRUG = 'DRUG',
}

export enum MEMBER_SOURCE_SYSTEM_NAME {
  TMG = 'TMG',
  TMG_MAPD = 'TMG_MAPD',
  DMDS = 'DMDS',
  VMS = 'VMS',
}

export enum MEMBER_LINE_OF_BUSINESS {
  GOVERNMENT = 'GOVERNMENT',
}

export enum CUSTOMER_SERVICE_NUMBER_FOR_VMS {
  IL = '1-800-624-1723',
  NM = '1-800-307-8144',
  OK = '1-800-722-3959',
  TX = '1-800-654-9390',
  MT = '', // TODO - add during integration of MT state for medsup
}

export enum CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDSUPP {
  IL = '1-877-384-9297',
  NM = '1-877-587-6623',
  OK = '1-877-587-6616',
  TX = '1-877-384-9307',
  MT = '1-855-520-1577',
}

export enum CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_PDP {
  IL = '1-888-285-2249',
  NM = '1-888-285-2249',
  OK = '1-888-285-2249',
  TX = '1-888-285-2249',
  MT = '1-888-285-2249',
}

export enum CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MAPD {
  IL = '1-877-774-8592',
  NM = '1-877-774-8592',
  OK = '1-877-774-8592',
  TX = '1-877-774-8592',
  MT = '1-877-774-8592',
}

// TODO - update during integration of respective customer service no changes for MEDICAID government member
export enum CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDICAID {
  IL = '',
  NM = '',
  OK = '',
  TX = '',
  MT = '',
}

/**
 * state in validate product details api
 */
export enum MEMBER_CORPORATE_CODE {
  IL1 = 'IL1',
  TX1 = 'TX1',
  OK1 = 'OK1',
  NM1 = 'NM1',
  MT1 = 'MT1',
}

/**
 * state in getGPDPaymentInformation api
 */
export enum MEMBER_STATE_CODE {
  IL = 'IL',
  TX = 'TX',
  OK = 'OK',
  NM = 'NM',
  MT = 'MT',
}

interface ICustomerServiceNumberConfiguration {
  VMS: {
    [key: string]: typeof CUSTOMER_SERVICE_NUMBER_FOR_VMS;
  };
  TMG: {
    [key: string]:
      | typeof CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDSUPP
      | typeof CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MAPD
      | typeof CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_PDP
      | typeof CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDICAID;
  };
}

export const CUSTOMER_SERVICE_NUMBER_CONFIGURATION: ICustomerServiceNumberConfiguration =
  {
    [MEMBER_DATA_SOURCE.VMS]: {
      [MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE_SUPPLEMENTAL]:
        CUSTOMER_SERVICE_NUMBER_FOR_VMS,
    },
    [MEMBER_DATA_SOURCE.TMG]: {
      [MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE_SUPPLEMENTAL]:
        CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDSUPP,
      [MEMBER_DERIVED_LOB.GOVERNMENT_MEDICAID]:
        CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MEDICAID,
      [MEMBER_DERIVED_LOB.GOVERNMENT_MEDICARE]:
        CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_MAPD,
      [MEMBER_DERIVED_LOB.GOVERNMENT_PDP]:
        CUSTOMER_SERVICE_NUMBER_FOR_GPD_TMG_PDP,
    },
  };
